import { reactive } from 'vue';
import PaymentApi from '../api/Payment';

const initialState = {
    loading: false,
    error: null,
    invoices: [],
    notInvoicedLines: [],
    notInvoicedAmount: null,
    notInvoicedAmountFormatted: null,
    showPaymentButton: false,
    invoiceHistory: [],
    hasVipps: false,
    hasNegativeBalance: true,
    totalBalanceAmount: 0,
    totalBalanceAmountFormatted: '',
};

const state = reactive({ ...initialState });

export default {
    init() {
        state.loading = true;
        state.error = null;
        PaymentApi.GetInvoicesAndNotInvoicedLines().then(res => {
            if (!res.success) {
                state.error = $t('Noe gikk galt. Prøv igjen senere.');
                return;
            }

            state.invoices = res.data.invoices;
            state.notInvoicedAmount = res.data.not_invoiced_amount;
            state.notInvoicedAmountFormatted = res.data.not_invoiced_amount_formatted;
            state.notInvoicedLines = res.data.not_invoiced_lines;
            state.showPaymentButton = res.data.show_payment_button;
            state.invoiceHistory = res.data.invoice_history;
            state.hasVipps = res.data.has_vipps;
            state.hasNegativeBalance = res.data.has_negative_balance;
            state.totalBalanceAmount = res.data.total_balance_amount;
            state.totalBalanceAmountFormatted = res.data.total_balance_amount_formatted;
        }).catch(() => {
            state.error = $t('Noe gikk galt. Prøv igjen senere.');
        }).finally(() => {
            state.loading = false;
        });
    },

    isLoading() {
        return state.loading;
    },
    hasError() {
        return state.error !== null && state.error.length > 0
    },
    getError() {
        return state.error
    },
    getInvoices() {
        return state.invoices
    },
    getNotInvoicedLines() {
        return state.notInvoicedLines
    },
    getNotInvoicedAmountFormatted() {
        return state.notInvoicedAmountFormatted
    },
    getShowPaymentButton() {
        return state.showPaymentButton
    },
    hasNegativeBalance() {
        return state.hasNegativeBalance
    },
    getTotalBalanceAmount() {
        return state.totalBalanceAmount
    },
    getTotalBalanceAmountFormatted() {
        return state.totalBalanceAmountFormatted
    },
    hasVipps() {
        return state.hasVipps
    },
    getInvoiceHistory() {
        return state.invoiceHistory
    },
};